import { useEffect, useState } from 'react';
import api from '../../../api';
import { GetNewsDetails } from '../../../utils/news-util';
import NewsTabConstant from '../../../constants/NewsTagConstant';
import { NEWS_IMAGE_PATH } from '../../../constants/PathsConstant';

export function useGetSingleNews(newsId) {
  const [newsDetailsState, setNewsDetailsState] = useState({ status: 'pending' });

  useEffect(() => {
    GetNewsDetails(newsId)
      .then((response) => {
        setNewsDetailsState({ status: 'fulfilled', data: response });
      })
      .catch((error) => {
        setNewsDetailsState({ status: 'rejected', error: error.message });
      });
  }, [newsId]);

  return newsDetailsState;
}

export function addDefaultSrc(ev) {
  ev.target.src = NewsTabConstant.NEWS_DEFAULT_IMG_PATH;
}

export function getDefaultSrc(newsDetails) {
  return `${NEWS_IMAGE_PATH}${encodeURI(newsDetails?.img)}`;
}

export function useSetVisitedToTrue(visited, newsid, userid) {
  useEffect(() => {
    api.post('/api/v2/news/postVisitorNewsLog', { userid, newsid, mode: '1', page: '/news' });
  }, []);
}
